import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { campaignApi } from "../../api/campaignApi";
import toast from 'react-hot-toast';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import * as React from 'react';
import * as Yup from 'yup';
import { alpha } from '@mui/material/styles';
import { grey } from '../../theme/tones';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DialogAddCommercials = (propsData) => {
  const theme = useTheme();
  const { setIsLoading, idCampaign, isLoading, openAddcommercials, setOpenAddcommercials, donnees, commercialsToAdd, selectedCommercials,
    selectedCommercialsEquitable, typeCampaign, commercialToAdd, setCommercialsToAdd, setDisplayEquitable, setDisplayNumberCustomers,
    setDisplayNumberCustomersNotAttributed, setDisplayReattribution, displayReattribution, commercialsCampaign, setSelectedCommercials,
    setSelectedCommercialsEquitable, displayEquitable, displayNumberCustomers, displayNumberCustomersNotAttributed, setNbCustomers,
    setNbCustomersNotAttributed, formIsEmpty } = propsData;

  const initialValuesAddCommercials = {
    type: '',
    nbCustomers: donnees.numberProspectsNotTreated !== undefined ? donnees.numberProspectsNotTreated.number : 0,
    nbCustomersNotAttributed: donnees.numberProspectsNotAttributedAttribuable !== undefined ? donnees.numberProspectsNotAttributedAttribuable.number : 0
  };

  const validationSchemaAddCommercials = Yup
    .object()
    .shape({
      type: Yup.string().required('Un type de répartition est requis'),
      nbCustomers: Yup.number().max(donnees.numberProspectsNotTreated !== undefined ? donnees.numberProspectsNotTreated.number : 0, 'Nombre trop grand'),
      nbCustomersNotAttributed: Yup.number().max(donnees.numberProspectsNotAttributedAttribuable !== undefined ? donnees.numberProspectsNotAttributedAttribuable.number : 0, 'Nombre trop grand'),
    });

  return (
    <Dialog
      open={openAddcommercials}
      onClose={() => setOpenAddcommercials(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Ajouter un commercial / des commerciaux</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialValuesAddCommercials}
          validationSchema={validationSchemaAddCommercials}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              setIsLoading(true);
              if (commercialsToAdd.length === 1) {
                await campaignApi.addCommercialToCampaign(idCampaign, commercialsToAdd, selectedCommercials, selectedCommercialsEquitable, typeCampaign, values, localStorage.getItem('accessToken'));
              } else if (commercialsToAdd.length > 1) {
                await campaignApi.addCommercialsToCampaign(idCampaign, commercialsToAdd, selectedCommercials, selectedCommercialsEquitable, typeCampaign, values, localStorage.getItem('accessToken'));
              }
              setStatus({ success: true });
              setSubmitting(false);
              toast.success('Ajout de commerciaux effectué avec succès');
              setOpenAddcommercials(false);
              setIsLoading(false);
              window.location.reload(false);
            } catch (err) {
              console.error(err);
              toast.error('Il y a eu un souci lors de l\'ajout des commerciaux !');
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
              setIsLoading(false);
            }
          }}
        >
          {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Box sx={{ mt: 1.5 }}>
                <Grid container spacing={3} alignItems="flex-start">
                  <Grid item xs={12} md={5}>
                    <Autocomplete
                      multiple
                      getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                      options={commercialToAdd || []}
                      disableClearable
                      disableCloseOnSelect
                      onChange={(e, value) => {
                        setCommercialsToAdd(value);
                      }}
                      value={commercialsToAdd}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="Commercial / Commerciaux à ajouter"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            sx: { borderRadius: '12px' }
                          }}
                        />
                      )}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {`${option.firstname} ${option.lastname}`}
                        </li>
                      )}
                    />
                  </Grid>
                  
                  <Grid item xs={12} md={7}>
                    <FormControl component="fieldset" fullWidth>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: theme.palette.text.secondary }}>
                        Répartition
                      </Typography>
                      <RadioGroup
                        row
                        name="type"
                        value={values.type}
                        onChange={(e) => {
                          const val = e.target.value;
                          setFieldValue('type', val);
                          if (val === 'Équitable') {
                            setDisplayNumberCustomers(false);
                            setDisplayReattribution(false);
                            setDisplayEquitable(true);
                            setDisplayNumberCustomersNotAttributed(false);
                          } else if (val === 'Nombre') {
                            setDisplayNumberCustomers(true);
                            setDisplayReattribution(false);
                            setDisplayEquitable(false);
                            setDisplayNumberCustomersNotAttributed(false);
                          } else if (val === 'Réattribution') {
                            setDisplayNumberCustomers(false);
                            setDisplayReattribution(true);
                            setDisplayEquitable(false);
                            setDisplayNumberCustomersNotAttributed(false);
                          } else if (val === 'Non Attribués') {
                            setDisplayNumberCustomers(false);
                            setDisplayReattribution(false);
                            setDisplayEquitable(false);
                            setDisplayNumberCustomersNotAttributed(true);
                          }
                        }}
                      >
                        <FormControlLabel
                          value="Équitable"
                          control={<Radio />}
                          label="Équitable"
                        />
                        <FormControlLabel
                          value="Nombre"
                          control={<Radio />}
                          label="Nombre à attribuer"
                        />
                        <FormControlLabel
                          value="Réattribution"
                          control={<Radio />}
                          label="Réattribution"
                        />
                        <FormControlLabel
                          value="Non Attribués"
                          control={<Radio />}
                          label="Non Attribués"
                        />
                      </RadioGroup>
                    </FormControl>

                    {errors.type && touched.type && (
                      <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
                        {errors.type}
                      </Typography>
                    )}
                    {errors.nbCustomers && (
                      <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
                        {errors.nbCustomers}
                      </Typography>
                    )}
                    {errors.nbCustomersNotAttributed && (
                      <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
                        {errors.nbCustomersNotAttributed}
                      </Typography>
                    )}

                    <Box sx={{ mt: 2 }}>
                      {displayReattribution && (
                        <Autocomplete
                          multiple
                          id="checkboxes-tags-add-commercial"
                          options={commercialsCampaign || []}
                          value={selectedCommercials}
                          disableCloseOnSelect
                          onChange={(event, newValue) => {
                            setSelectedCommercials(newValue);
                          }}
                          getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {`${option.firstname} ${option.lastname} (non traités : ${option.nbNotTreated})`}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Commerciaux à réattribuer"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                sx: { borderRadius: '12px' }
                              }}
                            />
                          )}
                        />
                      )}
                      {displayEquitable && (
                        <Autocomplete
                          multiple
                          id="checkboxes-tags-add-commercial-equitable"
                          options={commercialsCampaign || []}
                          value={selectedCommercialsEquitable}
                          disableCloseOnSelect
                          onChange={(event, newValue) => {
                            setSelectedCommercialsEquitable(newValue);
                          }}
                          getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {`${option.firstname} ${option.lastname} (non traités : ${option.nbNotTreated})`}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Commerciaux à ignorer"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                sx: { borderRadius: '12px' }
                              }}
                            />
                          )}
                        />
                      )}
                      {displayNumberCustomers && (
                        <TextField
                          fullWidth
                          label="Nombre d'apprenants"
                          type="number"
                          onChange={(event) => {
                            const val = parseInt(event.target.value, 10) || 0;
                            setFieldValue('nbCustomers', val);
                            setNbCustomers(val);
                          }}
                          value={values.nbCustomers}
                          variant="outlined"
                          InputProps={{ 
                            inputProps: { max: donnees.numberProspectsNotTreated?.number || 0, min: 0 },
                            sx: { borderRadius: '12px' } 
                          }}
                        />
                      )}
                      {displayNumberCustomersNotAttributed && (
                        <TextField
                          fullWidth
                          label="Nombre d'apprenants à attribuer"
                          type="number"
                          onChange={(event) => {
                            const val = parseInt(event.target.value, 10) || 0;
                            setFieldValue('nbCustomersNotAttributed', val);
                            setNbCustomersNotAttributed(val);
                          }}
                          value={values.nbCustomersNotAttributed}
                          variant="outlined"
                          InputProps={{ 
                            inputProps: { max: donnees.numberProspectsNotAttributedAttribuable?.number || 0, min: 0 },
                            sx: { borderRadius: '12px' } 
                          }}
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, pt: 3, pb: 1 }}>
                <Button
                  onClick={() => setOpenAddcommercials(false)}
                  color="inherit"
                  variant="outlined"
                  sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, borderColor: 'divider' }}
                >
                  Annuler
                </Button>
                <Button
                  onClick={handleSubmit}
                  disabled={isSubmitting || formIsEmpty || isLoading}
                  variant="contained"
                  sx={{
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                    color: grey(0),
                    borderRadius: '10px',
                    px: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: (theme) => `0 4px 12px 0 ${alpha(theme.palette.secondary.main, 0.25)}`,
                    '&:hover': {
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`
                    }
                  }}
                >
                  Enregistrer
                </Button>
                {isLoading && (
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <CircularProgress size={24} />
                  </Box>
                )}
              </Box>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default DialogAddCommercials;
